var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRbOperationsManual(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z",
    transform: "translate(-220 -1385.999) translate(220 1385.999)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21.871V6.999H0z",
    transform: "translate(-220 -1385.999) translate(-1318 568.001) translate(1538.875 825.937)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6 14H2v1.2h1.2v1.2a1.2 1.2 0 0 0 2.4 0H8a1.2 1.2 0 1 0 2.4 0v-1.2h7.2v1.2a1.2 1.2 0 0 0 2.4 0h2.4a1.2 1.2 0 1 0 2.4 0v-1.2H26V14h-8.4z",
    transform: "translate(-220 -1385.999) translate(-1318 568.001) translate(1536 820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2 5.2L10.8 4 6 6.4h14.4L15.6 4z",
    transform: "translate(-220 -1385.999) translate(-1318 568.001) translate(1536.8 818)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRbOperationsManual);
export default __webpack_public_path__ + "static/media/rb-operations-manual.c8b98d099adbfb509e649646c65543c1.svg";
export { ForwardRef as ReactComponent };